import { ICON__bars_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_navigate_ud } from '@/hooks/_base/use_navigate_ud';
import { use_slice_collections } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_6 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_6';

export function BAR_BUTTON__collections_all() {
  const navigate = use_navigate_ud();

  const { collection_current } = use_slice_collections(['collection_current']);

  async function onClick(e: React.MouseEvent) {
    let url_new = ENUM__page_type.BUILD_PATH_COLLECTIONS(collection_current._id);

    //sync slug with redux
    void navigate(url_new, { replace: true });
  }

  /*
   *
   */

  if (collection_current.is_stub()) return <PLACEHOLDER_BUTTON__bar_6 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      Icon={ICON__bars_solid}
      iconClassNameBase={`!text-component-item-foreground !size-4 !duration-300`}
      iconClassNameHovered="!text-bar-foreground"
      variant="no-border-on-component"
      {...{ onClick }}
      className={`p-0 rounded-lg  bg-bar  `}
    />
  );
}
